import React, { useState, useEffect } from 'react';
import { Phone } from 'lucide-react';
import { track, whatsappUrl } from '../lib/track';

// Logo officiel WhatsApp (glyphe)
const WhatsAppLogo = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.71.306 1.263.489 1.694.625.712.227 1.36.195 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z" />
  </svg>
);

// Contact flottant permanent (desktop + mobile) : Appel (principal) + WhatsApp (secondaire).
// Se décale intelligemment au-dessus de la bannière cookies pour ne jamais la masquer.
const FloatingContact = () => {
  const [bannerOpen, setBannerOpen] = useState(() => {
    if (typeof window === 'undefined') return false;
    return !localStorage.getItem('frelon33-cookie-consent');
  });
  const [bannerOffset, setBannerOffset] = useState(0);

  useEffect(() => {
    const decided = () => setBannerOpen(false);
    window.addEventListener('frelon33-consent-changed', decided);
    return () => window.removeEventListener('frelon33-consent-changed', decided);
  }, []);

  useEffect(() => {
    if (!bannerOpen) {
      setBannerOffset(0);
      return;
    }
    const measure = () => {
      const el = document.querySelector('[data-testid="cookie-banner"]');
      setBannerOffset(el ? el.offsetHeight + 16 : 0);
    };
    const t = setTimeout(measure, 1700); // la bannière apparaît après ~1.5s
    window.addEventListener('resize', measure);
    return () => {
      clearTimeout(t);
      window.removeEventListener('resize', measure);
    };
  }, [bannerOpen]);

  const handleCall = () => {
    track('phone_click', { location: 'floating' });
    window.location.href = 'tel:0676583038';
  };

  const bottomStyle =
    bannerOffset > 0
      ? { bottom: `${bannerOffset}px` }
      : { bottom: 'calc(1.5rem + env(safe-area-inset-bottom))' };

  return (
    <div
      className="fixed right-5 sm:right-6 z-[60] flex flex-col items-center gap-3 transition-[bottom] duration-300"
      style={bottomStyle}
      data-testid="floating-contact"
    >
      {/* WhatsApp - secondaire */}
      <a
        href={whatsappUrl()}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => track('whatsapp_click', { location: 'floating' })}
        aria-label="Contacter Frelon33 sur WhatsApp"
        className="w-14 h-14 rounded-full shadow-xl flex items-center justify-center text-white transition-transform duration-300 hover:scale-110 hover:shadow-2xl motion-reduce:transform-none motion-reduce:transition-none"
        style={{ backgroundColor: '#25D366' }}
        data-testid="mobile-floating-whatsapp-button"
        data-gtm-event="whatsapp_click"
      >
        <WhatsAppLogo className="h-7 w-7" />
      </a>

      {/* Appel - action principale */}
      <button
        onClick={handleCall}
        aria-label="Appeler Frelon33 au 06 76 58 30 38"
        className="frelon-btn-primary w-16 h-16 rounded-full shadow-2xl flex items-center justify-center transition-transform duration-300 hover:scale-110 motion-reduce:transform-none motion-reduce:transition-none"
        data-testid="mobile-floating-call-button"
        data-gtm-event="phone_click"
      >
        <Phone className="h-7 w-7 text-white" />
      </button>
    </div>
  );
};

export default FloatingContact;
